module.exports = __webpack_public_path__ + "img/PM_A01_front_en.1d8ead7f.png";